import React from 'react';
import type { TrackingPropsInterface } from '../../utils/enums/enums';

export enum MButtonType {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Tertiary = 'Tertiary',
}

export enum MButtonSize {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum MButtonIconPlacement {
  None = 'None',
  Leading = 'Leading',
  Trailing = 'Trailing',
}

export enum MButtonIconClass {
  Search = 'icon-search',
  ArrowRight = 'icon-arrow-right',
  ExternalArrow = 'icon-external-arrow',
  ForwardArrow = 'icon-forward-arrow',
  BackArrow = 'icon-back-arrow',
}

export interface MButtonAIcon {
  size?: string;
  icon: string;
}

export interface MButtonProps
  extends Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement> & React.AnchorHTMLAttributes<HTMLAnchorElement>,
    'children' | 'type'
  > {
  buttonText?: string;
  children?: React.ReactNode;

  /** Visual variant. Takes precedence over the deprecated `variant` prop. */
  buttonType?: MButtonType;
  /** @deprecated Prefer `buttonType`. */
  variant?: MButtonType;

  size?: MButtonSize;
  iconPlacement?: MButtonIconPlacement;
  iconClass?: string;
  aIcon?: MButtonAIcon;

  /** Link URL. Takes precedence over the deprecated `href` prop. */
  ctaLink?: string;
  /** @deprecated Prefer `ctaLink`. */
  href?: string;

  /** Whether the link opens in a new tab. Accepts boolean or string "true". Takes precedence over the deprecated `isExternal` prop. */
  openInANewTab?: boolean | string;
  /** @deprecated Prefer `openInANewTab`. */
  isExternal?: boolean;

  /** Accessible text for the external link icon. Defaults to DEFAULT_OPEN_IN_NEW_TAB_TEXT. */
  openInANewTabText?: string;

  type?: 'submit' | 'reset' | 'button';
  disabled?: boolean;
  target?: string;
  className?: string;
  trackingProperties?: TrackingPropsInterface;
  custom_click_track_value?: string;
  preTrackVal?: string;
}
